export default "__VITE_ASSET__22f8b1e3__"